import React from 'react'
import { View, Text, Image, Platform } from 'react-native'
import { getLanguage } from '../appBar/context/LocalizationContext'
import styles from './TriviaCardStyles'
import { LinearGradient } from 'expo-linear-gradient'
import theme from '../../../theme'
import { TriviaTheme } from '../../../themeConstants'
import { UserAvatarWeb } from '../web/UserAvatarWeb'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
const isWeb = Platform.OS === 'web'

// let CustomV
// if (Platform.OS !== 'web') {
//     CustomV = LinearGradient
// } else {
//     const CustomView = ({ style, children, ...rest }) => (
//         <View style={[{ backgroundColor: TriviaTheme.tabsUnselectedColor, borderRadius: 12, flexDirection: 'row' }, style]} {...rest}>
//             {children}
//         </View>
//     )
//     CustomV = CustomView
// }
export const TriviaCard = ({ position, points }) => {
    const { languageFile } = getLanguage()
    const gradientColors = !isWeb ? TriviaTheme.triviaGradient : [TriviaTheme.tabsUnselectedColor]
    const isMobile = useIsMobile()

    return (
        <View style={styles.invisibleContainer}>
            <LinearGradient
                style={[styles.container, isWeb && { borderRadius: 12, overflow: 'hidden', marginHorizontal: 12 }]}
                colors={gradientColors}
                start={{ x: 0, y: 0.5 }}
                end={{ x: 1, y: 0.5 }}
            >
                <View style={styles.feedbackAssetContainer}>
                    {!isWeb ? (
                        <Image style={styles.feedbackAsset} source={require('../../../assets/trivia/benefitsPoint.png')} />
                    ) : (
                        <UserAvatarWeb
                            style={{
                                width: 56,
                                flex: 1,
                                aspectRatio: 1,
                                borderRadius: 28,
                            }}
                            avatarUrl={''}
                        />
                    )}
                </View>

                <View style={[styles.levelKnowledgeBlock, styles.alignStart]}>
                    <View>
                        <View style={styles.containerData}>
                            <Text style={[styles.title]}>{languageFile.your_position + '  '}</Text>
                            <Text style={styles.value}>{position + '°'}</Text>
                        </View>

                        <Text style={[styles.subtitle, !isMobile && { fontSize: 16 }]}>
                            {languageFile.points + ' '}
                            {points}
                        </Text>
                    </View>
                </View>
            </LinearGradient>
        </View>
    )
}
